import { useApiGetGuestPaymentTransactionRequest } from '@hooks-api/fortune/useApiGetGuestPaymentTransactionRequest'
import { FastpassOrderStatus } from '@hooks-api/types/dataModel/fpOrder'
import { PaymentMethodMap, type PaymentMethodType } from '@hooks-api/types/dataModel/payment'
import { Box } from '@pets-ui/Box/Box'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom-v5'
import { useOrderPurchaseMessage } from '../hooks/use-order-puchase-message'
import { getPurchaseStatusClasses } from '../model/order-model'
import style from '../style/components/order-status.module.scss'

interface Props {
  payment?: PaymentMethodType
  status?: FastpassOrderStatus
  hasGiveaways: boolean
}

export const OrderStatus = (props: Props) => {
  const { payment, status, hasGiveaways } = props
  const { t } = useTranslation()
  const params = useParams<{ orderHash: string }>()
  const orderHash = params?.orderHash
  const { destructuredData: orderDetail } = useApiGetGuestPaymentTransactionRequest({ orderHash })
  const isCanceledOrder = orderDetail?.status === FastpassOrderStatus.CANCELED

  const orderPurchaseMessage = useOrderPurchaseMessage(status ?? '')

  const purchaseStatusClasses = getPurchaseStatusClasses(status ?? '', style)

  return (
    <section className={style.wrapper}>
      <div className={style.container}>
        <div className={style.row}>
          <span className={style.label}>{t('order.paymentStatus') + '：'}</span>
          <span className={purchaseStatusClasses}>{orderPurchaseMessage}</span>
        </div>
        <div className={style.row}>
          <span className={style.label}>{t('order.paymentMethod') + '：'}</span>
          <span className={style.value}>{payment ? PaymentMethodMap[payment] : ''}</span>
        </div>
        {hasGiveaways && !isCanceledOrder && (
          <Box backgroundColor={colors.grey100} color={colors.grey600} textAlign="center" py={1} borderRadius={4} mt={2}>
            <Text variant="body" align="center">
              {t(`thankyou.isGiveaways.${Number(hasGiveaways)}.isDispatch.${Number(!!orderDetail?.is_giveaway_dispatch)}`)}
            </Text>
          </Box>
        )}
      </div>
    </section>
  )
}
